import { NavLink } from 'react-router-dom';

/** The tabs of Reconciliation: one link per sub-page. Add a tab here, not in each page. */
const TABS = [
  { to: '/reconciliation/overview', label: 'Overview' },
  { to: '/reconciliation/bank-statements', label: 'Bank statements' },
  { to: '/reconciliation/insurer-receipts', label: 'Insurer receipts' },
  { to: '/reconciliation/insurer-ledger', label: 'Insurer ledger' },
  { to: '/reconciliation/ledger-match', label: 'Ledger match' },
];

export function ReconciliationTabs() {
  return (
    <nav aria-label="Reconciliation" className="mb-4 flex gap-1 border-b border-gray-200 dark:border-gray-700">
      {TABS.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          className={({ isActive }) =>
            `px-3 py-2 text-sm font-medium border-b-2 -mb-px ${
              isActive
                ? 'border-primary-600 text-primary-700 dark:text-primary-300'
                : 'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400'
            }`
          }
        >
          {t.label}
        </NavLink>
      ))}
    </nav>
  );
}
